import { render, staticRenderFns } from "./PreviewImageSidebar.vue?vue&type=template&id=8eba4b42&scoped=true&"
import script from "./PreviewImageSidebar.vue?vue&type=script&lang=ts&"
export * from "./PreviewImageSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewImageSidebar.vue?vue&type=style&index=0&id=8eba4b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eba4b42",
  null
  
)

export default component.exports